import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import publicService from '../services/publicService';
import LoadingSpinner from '../components/common/LoadingSpinner';
import Alert from '../components/common/Alert';
import { ROUTES } from '../utils/constants';
import './ApplicantPages.css';

// Opened from the emailed personal link: starts or resumes the application without a password.
const InviteLinkPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [state, setState] = useState('working'); // working | login | error
  const [message, setMessage] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return; // React StrictMode runs effects twice in development
    started.current = true;

    (async () => {
      try {
        const result = await publicService.redeemInvitation(token);
        if (result.login_required) {
          setState('login');
          return;
        }
        await loginWithToken(result.access_token);
        navigate(`/applicant/application/${result.application_id}`, { replace: true });
      } catch (err) {
        setMessage(err.response?.data?.message || 'This link could not be opened.');
        setState('error');
      }
    })();
  }, [token, loginWithToken, navigate]);

  return (
    <div className="ap-center">
      <div className="ap-card ap-card--narrow">
        <h1 className="ap-brand"><Link to={ROUTES.HOME}>TenantVerify SA</Link></h1>

        {state === 'working' && (
          <>
            <LoadingSpinner />
            <p>Opening your application...</p>
          </>
        )}

        {state === 'login' && (
          <>
            <h2>Log in to continue</h2>
            <p>
              An account already exists for this email address, so please log in with your password. Your
              application will be waiting under <strong>My Applications</strong>.
            </p>
            <Link className="btn-primary ap-button" to={ROUTES.LOGIN}>Log in</Link>
          </>
        )}

        {state === 'error' && (
          <>
            <Alert type="error" message={message} />
            <p>
              The link may have expired or been cancelled. Ask the landlord or agent to send you a new one.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default InviteLinkPage;
